import { render } from "./ProvinceMap.vue?vue&type=template&id=b680474a&scoped=true"
import script from "./ProvinceMap.vue?vue&type=script&lang=js"
export * from "./ProvinceMap.vue?vue&type=script&lang=js"

import "./ProvinceMap.vue?vue&type=style&index=0&id=b680474a&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b680474a"]])

export default __exports__